

export function init() {
	const el = document.querySelector('.company-nav')
	if (!el) return

	const observer = new IntersectionObserver(([e]) => {
		e.target.toggleAttribute('stuck', e.intersectionRatio < 1)
	}, {threshold: [1]})
	
	observer.observe(el)
}
